import { useQuery } from '@tanstack/react-query';
import { getDashboardRecords, getSlotAnalyticsRecords, getSlotSummaryRecords } from '../api/analyticsApi';
import { queryKeys } from '../api/queryKeys';

export function useDashboardAnalytics(params = {}, options = {}) {
  return useQuery({
    queryKey: queryKeys.analytics(params),
    queryFn: () => getDashboardRecords(params),
    ...options
  });
}

export function useSlotSummary(params = {}, options = {}) {
  return useQuery({
    queryKey: queryKeys.slotSummary(params),
    queryFn: () => getSlotSummaryRecords(params),
    ...options
  });
}

export function useSlotAnalytics(params = {}, options = {}) {
  return useQuery({
    queryKey: queryKeys.slotAnalytics(params),
    queryFn: () => getSlotAnalyticsRecords(params),
    ...options
  });
}
